export default "__VITE_ASSET__ByXt6wbK__"